// NotFound.js
import React from "react";
import { Button, Box, Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <Container
            component="main"
            maxWidth="xs"
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                textAlign: "center",
            }}
        >
            <Box>
                <Typography variant="h1" component="h1" gutterBottom>
                    403
                </Typography>
                <Typography variant="h5" component="p" gutterBottom>
                    Not Authorized
                </Typography>
                <Typography variant="body1" component="p" gutterBottom>
                    You do not have permission to view this page.
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => navigate("/")}
                    sx={{ mt: 2 }}
                >
                    Go to Main Menu
                </Button>
            </Box>
        </Container>
    );
};

export default NotFound;
